import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["message", "title", "code", "statusCode", "trace", "errors"];
import _Object$keys2 from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat-map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import Box from '@rexlabs/box';
import { useStyles, useToken, StyleSheet, StylesProvider } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Dialog } from './core';
var WarningCircle = Icons.WarningCircle;
var TITLES = {
  // Error code specfic
  404: 'Not found',
  401: 'Authentication failed',
  403: 'Permissions error',
  422: 'Validation failed',
  // Generic ranges
  '4xx': 'Unknown client error',
  '5xx': 'Unknown server error',
  // Generic fallback
  default: 'Something went wrong'
}; // TODO: this needs to be aligned with design once the designs are finalised

var tokens = {
  dialog: {
    background: {
      color: function color(_ref) {
        var token = _ref.token;
        return token('dialog.error.background.color', token('color.container.static.danger.contrast'));
      }
    }
  },
  button: {
    ghost: {
      hover: {
        border: {
          color: 'transparent'
        },
        background: {
          color: function color(_ref2) {
            var token = _ref2.token;
            return token('palette.tint.light.200');
          }
        }
      },
      active: {
        border: {
          color: 'transparent'
        },
        background: {
          color: function color(_ref3) {
            var token = _ref3.token;
            return token('palette.tint.light.300');
          }
        }
      }
    }
  }
};
var defaultStyles = StyleSheet({
  list: {
    padding: 'revert',
    listStyle: 'revert'
  },
  preformat: {
    font: 'revert'
  }
});
export function ErrorDialog(_ref4) {
  var _Object$keys;

  var message = _ref4.message,
      titleProp = _ref4.title,
      code = _ref4.code,
      statusCode = _ref4.statusCode,
      trace = _ref4.trace,
      _ref4$errors = _ref4.errors,
      errors = _ref4$errors === void 0 ? {} : _ref4$errors,
      props = _objectWithoutProperties(_ref4, _excluded);

  var s = useStyles(defaultStyles);
  var token = useToken();
  var errorCode = statusCode || code;
  var title = titleProp || (errorCode ? token("dialog.error.".concat(errorCode, ".title")) || TITLES[errorCode] || TITLES["".concat(errorCode[0], "xx")] || TITLES.default : TITLES.default);
  var validationErrors = (_Object$keys = _Object$keys2(errors)) === null || _Object$keys === void 0 ? void 0 : _flatMapInstanceProperty(_Object$keys).call(_Object$keys, function (field) {
    return errors[field];
  });
  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: tokens
  }, /*#__PURE__*/React.createElement(Dialog, _extends({
    intent: "alert",
    title: title,
    TitleIcon: WarningCircle
  }, props), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    sy: token('spacing.s')
  }, /*#__PURE__*/React.createElement(Box, null, message), errorCode === 422 && validationErrors.length > 0 && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("span", null, "Errors:"), /*#__PURE__*/React.createElement("ul", s('list'), _mapInstanceProperty(validationErrors).call(validationErrors, function (error, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, error);
  }))), trace && /*#__PURE__*/React.createElement("pre", s('preformat'), trace))));
}